/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_auth_create_account = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create an account`)
};

const es_auth_create_account = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear una cuenta`)
};

const de_auth_create_account = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konto erstellen`)
};

const nl_auth_create_account = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account aanmaken`)
};

const fr_auth_create_account = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créer un compte`)
};

const it_auth_create_account = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea un account`)
};

const pt_br2_auth_create_account = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criar uma conta`)
};

const pt_auth_create_account = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criar uma conta`)
};

const ja_auth_create_account = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アカウントを作成`)
};

const zh_auth_create_account = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建账户`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const auth_create_account = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.auth_create_account(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("auth_create_account", locale)
	if (locale === "en") return en_auth_create_account(inputs)
	if (locale === "es") return es_auth_create_account(inputs)
	if (locale === "de") return de_auth_create_account(inputs)
	if (locale === "nl") return nl_auth_create_account(inputs)
	if (locale === "fr") return fr_auth_create_account(inputs)
	if (locale === "it") return it_auth_create_account(inputs)
	if (locale === "pt-BR") return pt_br2_auth_create_account(inputs)
	if (locale === "pt") return pt_auth_create_account(inputs)
	if (locale === "ja") return ja_auth_create_account(inputs)
	return zh_auth_create_account(inputs)
};